import { FormBuilder, FormGroup, Validators } from "@angular/forms";

export interface Lead {
    automation: any;
    id: number,
    user_id: number,
    id_campaign: number,
    id_leadstatus: string,
    assign_lead: number,
    first_name: string,
    last_name: string,
    birth_date: string,
    age: string,
    street_address_1: string,
    street_address_2: string,
    city: string,
    state: string,
    county: string,
    zip: string,
    phone: string,
    cell_phone: string,
    work_phone: string,
    email: string,
    height: string,
    weight: string,
    lender: string,
    occupation: string,
    smoker: string,
    beneficiary: string,
    assign_date: string,
    lead_level: string,
    // salse_rep_name: string,
    spouse_full_name: string,
    spouse_age: string,
    spouse_birth_date: string,
    spouse_smoker: string,
    spouse_height: string,
    spouse_weight: string,
    spouse_occupation: string,
    purchase_refi: string,
    home_value: string,
    mortgage_term: string,
    mortgage_amount: string,
    monthly_mortage_payment: string,
    health_issue: string,
    status: string,
    spouse_health_issue: string,
    referrer: string,
    disposition: string,
    comments: string,
    didpick: string,
    dispoattempts: string,
    loan_amount: string,
    uploadstatus: string,
    dispodate: string,
    queued: string,
    callback_time: string,
    fullname: string,
    created_date: string,
    lead_script: string,
    description: string,
    agents: string,
    script_name: string,
    script_body: string,
    lead_field: number,
    field1: string,
    field2: string,
    field3: string,
    field4: string,
    field5: string,
    field6: string,
    field_map: string,
    pdf: string,

    field_1: string,
    field_2: string,
    field_3: string,
    field_4: string,
    field_5: string,
    field_6: string,
    field_7: string,
    field_8: string,
    field_9: string,
    field_10: string,
    field_11: string,
    field_12: string,
    field_13: string,
    field_14: string,
    field_15: string,
    field_16: string,
    field_17: string,
    field_18: string,
    field_19: string,
    field_20: string,
    field_21: string,
    field_22: string,
    field_23: string,
    field_24: string,
    field_25: string,
    field_26: string,
    field_27: string,
    field_28: string,
    field_29: string,
    field_30: string,
    field_31: string,
    field_32: string,
    field_33: string,
    field_34: string,
    field_35: string,
    field_36: string,
    field_37: string,
    field_38: string,
    field_39: string,
    field_40: string,
    field_41: string,
    field_42: string,
    field_43: string,
    field_44: string,
    field_45: string,
    field_46: string,
    field_47: string,
    field_48: string,
    field_49: string,
    field_50: string,
    lead_source: string
}

export interface HTTPLead {
    user_id: number,
    id_leadstatus: string,
    assign_lead: number,
    first_name: string,
    last_name: string,
    birth_date: string,
    age: string,
    street_address_1: string,
    street_address_2: string,
    city: string,
    state: string,
    county: string,
    zip: string,
    phone: string,
    cell_phone: string,
    work_phone: string,
    email: string,
    height: string,
    weight: string,
    lender: string,
    occupation: string,
    loan_amount: string,
    smoker: string,
    beneficiary: string,
    assign_date: string,
    // salse_rep_name: string,
    spouse_full_name: string,
    spouse_age: string,
    spouse_birth_date: string,
    spouse_smoker: string,
    spouse_height: string,
    spouse_weight: string,
    spouse_occupation: string,
    purchase_refi: string,
    home_value: string,
    mortgage_term: string,
    mortgage_amount: string,
    lead_level: string,
    monthly_mortage_payment: string,
    health_issue: string,
    spouse_health_issue: string,
    referrer: string,
    disposition: string,
    comments: string,
    didpick: string,
    dispoattempts: string,
    uploadstatus: string,
    dispodate: string,
    queued: string,
    callback_time: string,
    status: string,
    script_name: string,
    script_body: string,
    lead_field: number,
    field1: string,
    field2: string,
    field3: string,
    field4: string,
    field5: string,
    field6: string,
    created_date: string,
    pdf: string,

    field_1: string,
    field_2: string,
    field_3: string,
    field_4: string,
    field_5: string,
    field_6: string,
    field_7: string,
    field_8: string,
    field_9: string,
    field_10: string,
    field_11: string,
    field_12: string,
    field_13: string,
    field_14: string,
    field_15: string,
    field_16: string,
    field_17: string,
    field_18: string,
    field_19: string,
    field_20: string,
    field_21: string,
    field_22: string,
    field_23: string,
    field_24: string,
    field_25: string,
    field_26: string,
    field_27: string,
    field_28: string,
    field_29: string,
    field_30: string,
    field_31: string,
    field_32: string,
    field_33: string,
    field_34: string,
    field_35: string,
    field_36: string,
    field_37: string,
    field_38: string,
    field_39: string,
    field_40: string,
    field_41: string,
    field_42: string,
    field_43: string,
    field_44: string,
    field_45: string,
    field_46: string,
    field_47: string,
    field_48: string,
    field_49: string,
    field_50: string,
    lead_source: string
}

export class LeadForm implements HTTPLead {

    public user_id: number;
    public id_leadstatus: string;
    public assign_lead: number;
    public first_name: string;
    public last_name: string;
    public birth_date: string;
    public age: string;
    public street_address_1: string;
    public street_address_2: string;
    public city: string;
    public state: string;
    public county: string;
    public zip: string;
    public phone: string;
    public cell_phone: string;
    public work_phone: string;
    public email: string;
    public height: string;
    public weight: string;
    public lender: string;
    public occupation: string;
    public smoker: string;
    public beneficiary: string;
    public assign_date: string;
    // public salse_rep_name: string;
    public spouse_full_name: string;
    public lead_level: string;
    public spouse_age: string;
    public spouse_birth_date: string;
    public spouse_smoker: string;
    public spouse_height: string;
    public spouse_weight: string;
    public spouse_occupation: string;
    public purchase_refi: string;
    public home_value: string;
    public mortgage_term: string;
    public mortgage_amount: string;
    public monthly_mortage_payment: string;
    public health_issue: string;
    public spouse_health_issue: string;
    public referrer: string;
    public disposition: string;
    public comments: string;
    public didpick: string;
    public dispoattempts: string;
    public uploadstatus: string;
    public dispodate: string;
    public queued: string;
    public callback_time: string;
    public status: string;
    public script_name: string;
    public script_body: string;
    public lead_field: number;
    public field1: string;
    public field2: string;
    public field3: string;
    public field4: string;
    public field5: string;
    public field6: string;
    public loan_amount: string;
    public created_date: string;
    public pdf: string;

    public field_1: string;
    public field_2: string;
    public field_3: string;
    public field_4: string;
    public field_5: string;
    public field_6: string;
    public field_7: string;
    public field_8: string;
    public field_9: string;
    public field_10: string;
    public field_11: string;
    public field_12: string;
    public field_13: string;
    public field_14: string;
    public field_15: string;
    public field_16: string;
    public field_17: string;
    public field_18: string;
    public field_19: string;
    public field_20: string;
    public field_21: string;
    public field_22: string;
    public field_23: string;
    public field_24: string;
    public field_25: string;
    public field_26: string;
    public field_27: string;
    public field_28: string;
    public field_29: string;
    public field_30: string;
    public field_31: string;
    public field_32: string;
    public field_33: string;
    public field_34: string;
    public field_35: string;
    public field_36: string;
    public field_37: string;
    public field_38: string;
    public field_39: string;
    public field_40: string;
    public field_41: string;
    public field_42: string;
    public field_43: string;
    public field_44: string;
    public field_45: string;
    public field_46: string;
    public field_47: string;
    public field_48: string;
    public field_49: string;
    public field_50: string;
    public lead_source: string

    constructor(data: Lead) {
        if (data == null) {
            this.user_id = parseInt(sessionStorage.getItem('userid'));
            this.id_leadstatus = "";
            this.assign_lead = null;
            this.first_name = "";
            this.last_name = "";
            this.birth_date = "";
            this.age = "";
            this.street_address_1 = "";
            this.street_address_2 = "";
            this.city = "";
            this.state = "";
            this.county = "";
            this.zip = "";
            this.phone = "";
            this.cell_phone = "";
            this.work_phone = "";
            this.email = "";
            this.height = "";
            this.weight = "";
            this.lender = "";
            this.occupation = "";
            this.smoker = "";
            this.beneficiary = "";
            this.assign_date = "";
            // this.salse_rep_name = "";
            this.spouse_full_name = "";
            this.status = "";
            this.spouse_age = "";
            this.spouse_birth_date = "";
            this.spouse_smoker = "";
            this.spouse_height = "";
            this.spouse_weight = "";
            this.spouse_occupation = "";
            this.purchase_refi = "";
            this.home_value = "";
            this.mortgage_term = "";
            this.mortgage_amount = "";
            this.monthly_mortage_payment = "";
            this.health_issue = "";
            this.spouse_health_issue = "";
            this.referrer = "";
            this.disposition = "";
            this.comments = "";
            this.didpick = "";
            this.dispoattempts = "";
            this.uploadstatus = "";
            this.dispodate = "";
            this.queued = "";
            this.callback_time = "";
            this.lead_level = "";
            this.script_name = "";
            this.script_body = "";
            this.lead_field = -1;
            this.field1 = "";
            this.field2 = "";
            this.field3 = "";
            this.field4 = "";
            this.field5 = "";
            this.field6 = "";
            this.loan_amount = "";
            this.created_date = "";
            this.pdf = "";

            this.field_1 = "field 1"
            this.field_2 = "field 2"
            this.field_3 = "field 3"
            this.field_4 = "field 4"
            this.field_5 = "field 5"
            this.field_6 = "field 6"
            this.field_7 = "field 7"
            this.field_8 = "field 8"
            this.field_9 = "field 9"
            this.field_10 = "field 10"
            this.field_11 = "field 11"
            this.field_12 = "field 12"
            this.field_13 = "field 13"
            this.field_14 = "field 14"
            this.field_15 = "field 15"
            this.field_16 = "field 16"
            this.field_17 = "field 17"
            this.field_18 = "field 18"
            this.field_19 = "field 19"
            this.field_20 = "field 20"
            this.field_21 = "field 21"
            this.field_22 = "field 22"
            this.field_23 = "field 23"
            this.field_24 = "field 24"
            this.field_25 = "field 25"
            this.field_26 = "field 26"
            this.field_27 = "field 27"
            this.field_28 = "field 28"
            this.field_29 = "field 29"
            this.field_30 = "field 30"
            this.field_31 = "field 31"
            this.field_32 = "field 32"
            this.field_33 = "field 33"
            this.field_34 = "field 34"
            this.field_35 = "field 35"
            this.field_36 = "field 36"
            this.field_37 = "field 37"
            this.field_38 = "field 38"
            this.field_39 = "field 39"
            this.field_40 = "field 40"
            this.field_41 = "field 41"
            this.field_42 = "field 42"
            this.field_43 = "field 43"
            this.field_44 = "field 44"
            this.field_45 = "field 45"
            this.field_46 = "field 46"
            this.field_47 = "field 47"
            this.field_48 = "field 48"
            this.field_49 = "field 49"
            this.field_50 = "field 50"
            this.lead_source = "";
        } else {
            this.user_id = parseInt(sessionStorage.getItem('userid'));
            this.assign_lead = data.assign_lead;
            this.id_leadstatus = data.id_leadstatus;
            this.first_name = data.first_name;
            this.last_name = data.last_name;
            this.birth_date = data.birth_date;
            this.age = data.age;
            this.street_address_1 = data.street_address_1;
            this.street_address_2 = data.street_address_2;
            this.city = data.city;
            this.state = data.state;
            this.county = data.county;
            this.zip = data.zip;
            this.phone = data.phone;
            this.cell_phone = data.cell_phone;
            this.work_phone = data.work_phone;
            this.email = data.email;
            this.height = data.height;
            this.weight = data.weight;
            this.lender = data.lender;
            this.occupation = data.occupation;
            this.smoker = data.smoker;
            this.beneficiary = data.beneficiary;
            this.status = data.status
            this.assign_date = data.assign_date;
            // // this.salse_rep_name = data.salse_rep_name;
            this.spouse_full_name = data.spouse_full_name;
            this.spouse_age = data.spouse_age;
            this.spouse_birth_date = data.spouse_birth_date;
            this.spouse_smoker = data.spouse_smoker;
            this.loan_amount = data.loan_amount;
            this.spouse_height = data.spouse_height;
            this.spouse_weight = data.spouse_weight;
            this.spouse_occupation = data.spouse_occupation;
            this.purchase_refi = data.purchase_refi;
            this.home_value = data.home_value;
            this.lead_level = data.lead_level;
            this.mortgage_term = data.mortgage_term;
            this.mortgage_amount = data.mortgage_amount;
            this.monthly_mortage_payment = data.monthly_mortage_payment;
            this.health_issue = data.health_issue;
            this.spouse_health_issue = data.spouse_health_issue;
            this.referrer = data.referrer;
            this.disposition = data.disposition;
            this.comments = data.comments;
            this.didpick = data.didpick;
            this.dispoattempts = data.dispoattempts;
            this.uploadstatus = data.uploadstatus;
            this.dispodate = data.dispodate;
            this.queued = data.queued;
            this.callback_time = data.callback_time;
            this.script_name = data.script_name;
            this.script_body = data.script_body;
            this.lead_field = data.lead_field;
            this.field1 = data.field1;
            this.field2 = data.field2;
            this.field3 = data.field3;
            this.field4 = data.field4;
            this.field5 = data.field5;
            this.field6 = data.field6;
            this.created_date = data.created_date;
            this.pdf = data.pdf;
            this.lead_source = data.lead_source
        }
    }

    public makeform(fb: FormBuilder): FormGroup {
        return fb.group({
            assign_lead: [this.assign_lead],
            id_leadstatus: [this.id_leadstatus],
            first_name: [this.first_name],
            last_name: [this.last_name],
            birth_date: [this.birth_date],
            age: [this.age],
            street_address_1: [this.street_address_1],
            street_address_2: [this.street_address_2],
            city: [this.city],
            state: [this.state],
            county: [this.county],
            zip: [this.zip],
            phone: [this.phone],
            cell_phone: [this.cell_phone],
            work_phone: [this.work_phone],
            email: [this.email],
            height: [this.height],
            weight: [this.weight],
            lender: [this.lender],
            occupation: [this.occupation],
            smoker: [this.smoker],
            beneficiary: [this.beneficiary],
            status: [this.status],
            loan_amount: [this.loan_amount],
            assign_date: [this.assign_date],
            // // salse_rep_name: [this.salse_rep_name],
            spouse_full_name: [this.spouse_full_name],
            spouse_age: [this.spouse_age],
            spouse_birth_date: [this.spouse_birth_date],
            spouse_smoker: [this.spouse_smoker],
            spouse_height: [this.spouse_height],
            spouse_weight: [this.spouse_weight],
            spouse_occupation: [this.spouse_occupation],
            purchase_refi: [this.purchase_refi],
            home_value: [this.home_value],
            mortgage_term: [this.mortgage_term],
            mortgage_amount: [this.mortgage_amount],
            monthly_mortage_payment: [this.monthly_mortage_payment],
            health_issue: [this.health_issue],
            spouse_health_issue: [this.spouse_health_issue],
            referrer: [this.referrer],
            disposition: [this.disposition],
            comments: [this.comments],
            didpick: [this.didpick],
            dispoattempts: [this.dispoattempts],
            uploadstatus: [this.uploadstatus],
            dispodate: [this.dispodate],
            queued: [this.queued],
            lead_level: [this.lead_level],
            callback_time: [this.callback_time],
            script_name: [this.script_name],
            script_body: [this.script_body],
            lead_field: [this.lead_field],
            field1: [this.field1],
            field2: [this.field2],
            field3: [this.field3],
            field4: [this.field4],
            field5: [this.field5],
            field6: [this.field6],
            created_date: [this.created_date],
            pdf: [this.pdf],

            field_1: [this.field_1],
            field_2: [this.field_2],
            field_3: [this.field_3],
            field_4: [this.field_4],
            field_5: [this.field_5],
            field_6: [this.field_6],
            field_7: [this.field_7],
            field_8: [this.field_8],
            field_9: [this.field_9],
            field_10: [this.field_10],
            field_11: [this.field_11],
            field_12: [this.field_12],
            field_13: [this.field_13],
            field_14: [this.field_14],
            field_15: [this.field_15],
            field_16: [this.field_16],
            field_17: [this.field_17],
            field_18: [this.field_18],
            field_19: [this.field_19],
            field_20: [this.field_20],
            field_21: [this.field_21],
            field_22: [this.field_22],
            field_23: [this.field_23],
            field_24: [this.field_24],
            field_25: [this.field_25],
            field_26: [this.field_26],
            field_27: [this.field_27],
            field_28: [this.field_28],
            field_29: [this.field_29],
            field_30: [this.field_30],
            field_31: [this.field_31],
            field_32: [this.field_32],
            field_33: [this.field_33],
            field_34: [this.field_34],
            field_35: [this.field_35],
            field_36: [this.field_36],
            field_37: [this.field_37],
            field_38: [this.field_38],
            field_39: [this.field_39],
            field_40: [this.field_40],
            field_41: [this.field_41],
            field_42: [this.field_42],
            field_43: [this.field_43],
            field_44: [this.field_44],
            field_45: [this.field_45],
            field_46: [this.field_46],
            field_47: [this.field_47],
            field_48: [this.field_48],
            field_49: [this.field_49],
            field_50: [this.field_50],
            lead_source: [this.lead_source]
        });
    }

    public saveForm(fg: FormGroup): boolean {
        if (fg.valid) {
            this.user_id = parseInt(sessionStorage.getItem('userid'));
            this.assign_lead = fg.get("assign_lead").value;
            this.id_leadstatus = fg.get("id_leadstatus").value;
            this.first_name = fg.get("first_name").value;
            this.last_name = fg.get("last_name").value;
            this.birth_date = fg.get("birth_date").value;
            this.age = fg.get("age").value;
            this.street_address_1 = fg.get("street_address_1").value;
            this.street_address_2 = fg.get("street_address_2").value;
            this.city = fg.get("city").value;
            this.state = fg.get("state").value;
            this.county = fg.get("county").value;
            this.zip = fg.get("zip").value;
            this.phone = fg.get("phone").value;
            this.cell_phone = fg.get("cell_phone").value;
            this.work_phone = fg.get("work_phone").value;
            this.email = fg.get("email").value;
            this.height = fg.get("height").value;
            this.weight = fg.get("weight").value;
            this.loan_amount = fg.get("loan_amount").value;
            this.lender = fg.get("lender").value;
            this.occupation = fg.get("occupation").value;
            this.smoker = fg.get("smoker").value;
            this.beneficiary = fg.get("beneficiary").value;
            this.status = fg.get("status").value;
            this.assign_date = fg.get("assign_date").value;
            // // this.salse_rep_name = fg.get("salse_rep_name").value;
            this.spouse_full_name = fg.get("spouse_full_name").value;
            this.spouse_age = fg.get("spouse_age").value;
            this.spouse_birth_date = fg.get("spouse_birth_date").value;
            this.spouse_smoker = fg.get("spouse_smoker").value;
            this.spouse_height = fg.get("spouse_height").value;
            this.spouse_weight = fg.get("spouse_weight").value;
            this.spouse_occupation = fg.get("spouse_occupation").value;
            this.purchase_refi = fg.get("purchase_refi").value;
            this.home_value = fg.get("home_value").value;
            this.mortgage_term = fg.get("mortgage_term").value;
            this.mortgage_amount = fg.get("mortgage_amount").value;
            this.monthly_mortage_payment = fg.get("monthly_mortage_payment").value;
            this.health_issue = fg.get("health_issue").value;
            this.spouse_health_issue = fg.get("spouse_health_issue").value;
            this.referrer = fg.get("referrer").value;
            this.disposition = fg.get("disposition").value;
            this.comments = fg.get("comments").value;
            this.didpick = fg.get("didpick").value;
            this.dispoattempts = fg.get("dispoattempts").value;
            this.uploadstatus = fg.get("uploadstatus").value;
            this.dispodate = fg.get("dispodate").value;
            this.queued = fg.get("queued").value;
            this.callback_time = fg.get("callback_time").value;
            this.lead_level = fg.get("lead_level").value;
            this.script_name = fg.get("script_name").value;
            this.script_body = fg.get("script_body").value;
            this.lead_field = fg.get("lead_field").value;
            this.field1 = fg.get("field1").value;
            this.field2 = fg.get("field2").value;
            this.field3 = fg.get("field3").value;
            this.field4 = fg.get("field4").value;
            this.field5 = fg.get("field5").value;
            this.field6 = fg.get("field6").value;
            this.created_date = fg.get("created_date").value;
            this.pdf = fg.get("pdf").value;

            this.field_1 = fg.get("field_1").value
            this.field_2 = fg.get("field_2").value
            this.field_3 = fg.get("field_3").value
            this.field_4 = fg.get("field_4").value
            this.field_5 = fg.get("field_5").value
            this.field_6 = fg.get("field_6").value
            this.field_7 = fg.get("field_7").value
            this.field_8 = fg.get("field_8").value
            this.field_9 = fg.get("field_9").value
            this.field_10 = fg.get("field_10").value
            this.field_11 = fg.get("field_11").value
            this.field_12 = fg.get("field_12").value
            this.field_13 = fg.get("field_13").value
            this.field_14 = fg.get("field_14").value
            this.field_15 = fg.get("field_15").value
            this.field_16 = fg.get("field_16").value
            this.field_17 = fg.get("field_17").value
            this.field_18 = fg.get("field_18").value
            this.field_19 = fg.get("field_19").value
            this.field_20 = fg.get("field_20").value
            this.field_21 = fg.get("field_21").value
            this.field_22 = fg.get("field_22").value
            this.field_23 = fg.get("field_23").value
            this.field_24 = fg.get("field_24").value
            this.field_25 = fg.get("field_25").value
            this.field_26 = fg.get("field_26").value
            this.field_27 = fg.get("field_27").value
            this.field_28 = fg.get("field_28").value
            this.field_29 = fg.get("field_29").value
            this.field_30 = fg.get("field_30").value
            this.field_31 = fg.get("field_31").value
            this.field_32 = fg.get("field_32").value
            this.field_33 = fg.get("field_33").value
            this.field_34 = fg.get("field_34").value
            this.field_35 = fg.get("field_35").value
            this.field_36 = fg.get("field_36").value
            this.field_37 = fg.get("field_37").value
            this.field_38 = fg.get("field_38").value
            this.field_39 = fg.get("field_39").value
            this.field_40 = fg.get("field_40").value
            this.field_41 = fg.get("field_41").value
            this.field_42 = fg.get("field_42").value
            this.field_43 = fg.get("field_43").value
            this.field_44 = fg.get("field_44").value
            this.field_45 = fg.get("field_45").value
            this.field_46 = fg.get("field_46").value
            this.field_47 = fg.get("field_47").value
            this.field_48 = fg.get("field_48").value
            this.field_49 = fg.get("field_49").value
            this.field_50 = fg.get("field_50").value
            this.lead_source = fg.get("lead_source").value
            return true;
        }
        else {
            return false;
        }
    }
}


export interface Summary {
    id: number,
    user_id: number,
    id_campaign: number,
    lead_type: number,
    agent_type: number,
    assign_lead: number,
    county: string,
    state: string,
    city: string,
    zip: string,
    assign_from: string,
    assign_to: string,
    upload_from: string,
    upload_to: string,
    id_leadstatus: number,
    disposition: string,

    lead_type_1: number,
    id_leadstatus_1: number,
    disposition_1: any[],

    lead_type_2: number,
    id_leadstatus_2: number,
    disposition_2: any[],

    lead_type_3: number,
    id_leadstatus_3: number,
    disposition_3: any[]
}

export interface HTTPSummary {
    user_id: number,
    id_campaign: number,
    lead_type: number,
    agent_type: number,
    assign_lead: number,
    county: string,
    state: string,
    city: string,
    zip: string,
    assign_from: string,
    assign_to: string,
    upload_from: string,
    upload_to: string,
    id_leadstatus: number,
    disposition: string,

    lead_type_1: number,
    id_leadstatus_1: number,
    disposition_1: any[],

    lead_type_2: number,
    id_leadstatus_2: number,
    disposition_2: any[],

    lead_type_3: number,
    id_leadstatus_3: number,
    disposition_3: any[]
}

export class SummaryForm implements HTTPSummary {

    public user_id: number;
    public id_campaign: number;
    public lead_type: number;
    public agent_type: number;
    public assign_lead: number;
    public county: string;
    public state: string;
    public city: string;
    public zip: string;
    public assign_from: string;
    public assign_to: string;
    public upload_from: string;
    public upload_to: string;
    public id_leadstatus: number;
    public disposition: string;

    public lead_type_1: number;
    public id_leadstatus_1: number;
    public disposition_1: any[];

    public lead_type_2: number;
    public id_leadstatus_2: number;
    public disposition_2: any[];

    public lead_type_3: number;
    public id_leadstatus_3: number;
    public disposition_3: any[];

    constructor(data: Summary) {
        if (data == null) {
            this.user_id = parseInt(sessionStorage.getItem('userid'));
            this.id_campaign = null;
            this.lead_type = -1;
            this.agent_type = 0;
            this.assign_lead = 0;
            this.county = null;
            this.state = null;
            this.city = null;
            this.zip = null;
            this.assign_from = null;
            this.assign_to = null;
            this.upload_from = null;
            this.upload_to = null;
            this.id_leadstatus = -1;
            this.disposition = null;

            this.lead_type_1 = -1;
            this.id_leadstatus_1 = -1;
            this.disposition_1 = [];

            this.lead_type_2 = -1;
            this.id_leadstatus_2 = -1;
            this.disposition_2 = [];

            this.lead_type_3 = -1;
            this.id_leadstatus_3 = -1;
            this.disposition_3 = [];
        }
        else {
            this.user_id = parseInt(sessionStorage.getItem('userid'));
            this.id_campaign = data.id_campaign;
            this.lead_type = data.lead_type;
            this.agent_type = data.agent_type;
            this.assign_lead = data.assign_lead;
            this.county = data.county;
            this.state = data.state;
            this.city = data.city;
            this.zip = data.zip;
            this.assign_from = data.assign_from;
            this.assign_to = data.assign_to;
            this.upload_from = data.upload_from;
            this.upload_to = data.upload_to;
            this.id_leadstatus = data.id_leadstatus;
            this.disposition = data.disposition;

            this.lead_type_1 = data.lead_type_1;
            this.id_leadstatus_1 = data.id_leadstatus_1;
            this.disposition_1 = data.disposition_1;

            this.lead_type_2 = data.lead_type_2;
            this.id_leadstatus_2 = data.id_leadstatus_2;
            this.disposition_2 = data.disposition_2;

            this.lead_type_3 = data.lead_type_3;
            this.id_leadstatus_3 = data.id_leadstatus_3;
            this.disposition_3 = data.disposition_3;
        }
    }

    public makeform(fb: FormBuilder): FormGroup {
        return fb.group({
            id_campaign: [this.id_campaign],
            lead_type: [this.lead_type],
            agent_type: [this.agent_type],
            assign_lead: [this.assign_lead],
            county: [this.county],
            state: [this.state],
            city: [this.city],
            zip: [this.zip],
            assign_from: [this.assign_from],
            assign_to: [this.assign_to],
            upload_from: [this.upload_from],
            upload_to: [this.upload_to],
            id_leadstatus: [this.id_leadstatus],
            disposition: [this.disposition],

            lead_type_1: [this.lead_type_1],
            id_leadstatus_1: [this.id_leadstatus_1],
            disposition_1: [this.disposition_1],

            lead_type_2: [this.lead_type_2],
            id_leadstatus_2: [this.id_leadstatus_2],
            disposition_2: [this.disposition_2],

            lead_type_3: [this.lead_type_3],
            id_leadstatus_3: [this.id_leadstatus_3],
            disposition_3: [this.disposition_3],
        });
    }

    public saveForm(fg: FormGroup): boolean {
        if (fg.valid) {
            this.user_id = parseInt(sessionStorage.getItem('userid'));
            this.id_campaign = fg.get("id_campaign").value;
            this.lead_type = fg.get("lead_type").value;
            this.agent_type = fg.get("agent_type").value;
            this.assign_lead = fg.get("assign_lead").value;
            this.county = fg.get("county").value;
            this.state = fg.get("state").value;
            this.city = fg.get("city").value;
            this.zip = fg.get("zip").value;
            this.assign_from = fg.get("assign_from").value;
            this.assign_to = fg.get("assign_to").value;
            this.upload_from = fg.get("upload_from").value;
            this.upload_to = fg.get("upload_to").value;
            this.id_leadstatus = fg.get("id_leadstatus").value;
            this.disposition = fg.get("disposition").value;

            this.lead_type_1 = fg.get("lead_type_1").value;
            this.id_leadstatus_1 = fg.get("id_leadstatus_1").value;
            this.disposition_1 = fg.get("disposition_1").value;

            this.lead_type_2 = fg.get("lead_type_2").value;
            this.id_leadstatus_2 = fg.get("id_leadstatus_2").value;
            this.disposition_2 = fg.get("disposition_2").value;

            this.lead_type_3 = fg.get("lead_type_3").value;
            this.id_leadstatus_3 = fg.get("id_leadstatus_3").value;
            this.disposition_3 = fg.get("disposition_3").value;

            return true;
        }
        else {
            return false;
        }
    }
}


export interface DuplicateLeads {
    id: number,
    phone: number,
    cell_phone: number,
    work_phone: number,
    first_name: number,
    last_name: number,
    email: number,
    street_address_1: number,
    street_address_2: number,
    state: number,
    county: number,
    city: number,
    zip: number,
    spouse_full_name: number,
    birth_date: number,
    spouse_birth_date: number
}

export interface HTTPDuplicateLeads {
    phone: number,
    cell_phone: number,
    work_phone: number,
    first_name: number,
    last_name: number,
    email: number,
    street_address_1: number,
    street_address_2: number,
    state: number,
    county: number,
    city: number,
    zip: number,
    spouse_full_name: number,
    birth_date: number,
    spouse_birth_date: number
}

export class DuplicateLeadsForm implements HTTPDuplicateLeads {

    public phone: number;
    public cell_phone: number;
    public work_phone: number;
    public first_name: number;
    public last_name: number;
    public email: number;
    public street_address_1: number;
    public street_address_2: number;
    public state: number;
    public county: number;
    public city: number;
    public zip: number;
    public spouse_full_name: number;
    public birth_date: number;
    public spouse_birth_date: number;

    constructor(data: DuplicateLeads) {
        if (data == null) {
            this.phone = 0;
            this.cell_phone = 0;
            this.work_phone = 0;
            this.first_name = 0;
            this.last_name = 0;
            this.email = 0;
            this.street_address_1 = 0;
            this.street_address_2 = 0;
            this.state = 0;
            this.county = 0;
            this.city = 0;
            this.zip = 0;
            this.spouse_full_name = 0;
            this.birth_date = 0;
            this.spouse_birth_date = 0;
        }
        else {
            this.phone = data.phone;;
            this.cell_phone = data.cell_phone;
            this.work_phone = data.work_phone;
            this.first_name = data.first_name;
            this.last_name = data.last_name;
            this.email = data.email;;
            this.street_address_1 = data.street_address_1;
            this.street_address_2 = data.work_phone;
            this.state = data.state;
            this.county = data.county;
            this.city = data.city;;
            this.zip = data.zip;
            this.spouse_full_name = data.spouse_full_name;
            this.birth_date = data.birth_date;
            this.spouse_birth_date = data.county;
        }
    }

    public makeform(fb: FormBuilder): FormGroup {
        return fb.group({
            phone: [this.phone],
            cell_phone: [this.cell_phone],
            work_phone: [this.work_phone],
            first_name: [this.first_name],
            last_name: [this.last_name],
            email: [this.email],
            street_address_1: [this.street_address_1],
            street_address_2: [this.street_address_2],
            state: [this.state],
            county: [this.county],
            city: [this.city],
            zip: [this.zip],
            spouse_full_name: [this.spouse_full_name],
            birth_date: [this.birth_date],
            spouse_birth_date: [this.spouse_birth_date],
        });
    }

    public saveForm(fg: FormGroup): boolean {
        if (fg.valid) {
            this.phone = fg.get("phone").value;
            this.cell_phone = fg.get("cell_phone").value;
            this.work_phone = fg.get("work_phone").value;
            this.first_name = fg.get("first_name").value;
            this.last_name = fg.get("last_name").value;
            this.email = fg.get("email").value;
            this.street_address_1 = fg.get("street_address_1").value;
            this.street_address_2 = fg.get("street_address_2").value;
            this.state = fg.get("state").value;
            this.county = fg.get("county").value;
            this.city = fg.get("city").value;
            this.zip = fg.get("zip").value;
            this.spouse_full_name = fg.get("spouse_full_name").value;
            this.birth_date = fg.get("birth_date").value;
            this.spouse_birth_date = fg.get("spouse_birth_date").value;
            return true;
        }
        else {
            return false;
        }
    }
}

export interface leadedetails {
    occupation: string,
    birth_date: string,
    age: string,
    height: string,
    weight: string,
    spouse_full_name: string,
    spouse_age: string,
    spouse_birth_date: string,
    spouse_height: string,
    spouse_weight: string,
    spouse_occupation: string,
    // spouse_smoker: string,
}

export interface HTTPleadedetails {
    occupation: string,
    birth_date: string,
    age: string,
    height: string,
    weight: string,
    spouse_full_name: string,
    spouse_age: string,
    spouse_birth_date: string,
    spouse_height: string,
    spouse_weight: string,
    spouse_occupation: string
    // spouse_smoker: string,
}
export class leadedetailsFrom implements HTTPleadedetails {
    public occupation: string;
    public birth_date: string;
    public age: string;
    public height: string;
    public weight: string;
    public spouse_full_name: string;
    public spouse_age: string;
    public spouse_birth_date: string;
    public spouse_height: string;
    public spouse_weight: string;
    public spouse_occupation: string;
    constructor(data: leadedetails) {
        if (data == null) {
            this.occupation = "";
            this.birth_date = "";
            this.age = "";
            this.height = "";
            this.weight = "";
            this.spouse_full_name = "";
            this.spouse_age = "";
            this.spouse_birth_date = "";
            this.spouse_height = "";
            this.spouse_weight = "";
            this.spouse_occupation = "";
        } else {
            this.occupation = data.occupation;
            this.birth_date = data.birth_date;
            this.age = data.age;
            this.height = data.height;
            this.weight = data.weight;
            this.spouse_full_name = data.spouse_full_name;
            this.spouse_age = data.spouse_age;
            this.spouse_birth_date = data.spouse_birth_date;
            this.spouse_height = data.spouse_height;
            this.spouse_weight = data.spouse_weight;
            this.spouse_occupation = data.spouse_occupation;
        }
    }
    public makeform(fb: FormBuilder): FormGroup {
        return fb.group({
            occupation : [this.occupation],
            birth_date : [this.birth_date],
            age : [this.age],
            height : [this.height],
            weight : [this.weight],
            spouse_full_name : [this.spouse_full_name],
            spouse_age : [this.spouse_age],
            spouse_birth_date : [this.spouse_birth_date],
            spouse_height : [this.spouse_height],
            spouse_weight : [this.spouse_weight],
            spouse_occupation : [this.spouse_occupation],
        })
    }

}


export class VariableParse {
    public EmailInsurance(tempdata: any, callback: (error: any, data: any) => void) {
        let email_body = tempdata.template;
        let leaddata = tempdata.cdata;
        email_body = email_body.replace(/{FIRST_NAME}/g, leaddata.first_name);

        email_body = email_body.replace(/{LAST_NAME}/g, leaddata.last_name);
        email_body = email_body.replace(/{SPOUSE_FULL_NAME}/g, leaddata.spouse_full_name);
        email_body = email_body.replace(/{STREET_ADDRESS_1}/g, leaddata.street_address_1);
        email_body = email_body.replace(/{STREET_ADDRESS_2}/g, leaddata.street_address_2);
        email_body = email_body.replace(/{CITY}/g, leaddata.city);
        email_body = email_body.replace(/{STATE}/g, leaddata.state);
        email_body = email_body.replace(/{ZIP}/g, leaddata.zip);
        email_body = email_body.replace(/{COUNTY}/g, leaddata.county);
        email_body = email_body.replace(/{LEAD_SOURCE}/g, leaddata.lead_source);
        email_body = email_body.replace(/{RESCHEDULE_APPOINTMENT}/g, leaddata.reschedule_appointment);
        email_body = email_body.replace(/{APPOINTMENT_DATE}/g, leaddata.date);
        email_body = email_body.replace(/{APPOINTMENTS_DATE}/g, leaddata.date);
        email_body = email_body.replace(/{APPOINTMENT_TIME}/g, leaddata.from_or_contact_time + "-" + leaddata.to_or_agent_time);
        email_body = email_body.replace(/{APPOINTMENT_START_TIME}/g, leaddata.from_or_contact_time);
        email_body = email_body.replace(/{APPOINTMENT_END_TIME}/g, leaddata.to_or_agent_time);
        email_body = email_body.replace(/{APPOINTMENT_COMMENTS}/g, leaddata.comments);
        email_body = email_body.replace(/{CANCEL}/g, leaddata.cancel_appointment);
        if (leaddata.place) {
            email_body = email_body.replace(/{APPOINTMENT_PLACE}/g, leaddata.place);
            email_body = email_body.replace(/{ZOOM}/g, leaddata.place);
        }
        else {
            email_body = email_body.replace(/{APPOINTMENT_PLACE}/g, " ");
            email_body = email_body.replace(/{ZOOM}/g, " ");
        }
        email_body = email_body.replace(/{PHONE}/g, leaddata.phone);
        email_body = email_body.replace(/{CELL_PHONE}/g, leaddata.cell_phone);
        email_body = email_body.replace(/{WORK_PHONE}/g, leaddata.work_phone);
        email_body = email_body.replace(/{EMAIL}/g, leaddata.email);
        email_body = email_body.replace(/{BIRTH_DATE}/g, leaddata.birth_date);
        email_body = email_body.replace(/{AGE}/g, leaddata.age);
        email_body = email_body.replace(/{HEIGHT}/g, leaddata.height);
        email_body = email_body.replace(/{WEIGHT}/g, leaddata.weight);
        email_body = email_body.replace(/{SMOKER}/g, leaddata.smoker);
        email_body = email_body.replace(/{SPOUSE_BIRTH_DATE}/g, leaddata.spouse_birth_date);
        email_body = email_body.replace(/{SPOUSE_AGE}/g, leaddata.spouse_age);
        email_body = email_body.replace(/{SPOUSE_HEIGHT}/g, leaddata.spouse_height);
        email_body = email_body.replace(/{SPOUSE_WEIGHT}/g, leaddata.spouse_weight);
        email_body = email_body.replace(/{SPOUSE_SMOKER}/g, leaddata.spouse_smoker);
        email_body = email_body.replace(/{HEALTH_ISSUE}/g, leaddata.health_issue);
        email_body = email_body.replace(/{SPOUSE_HEALTH_ISSUE}/g, leaddata.spouse_health_issue);
        email_body = email_body.replace(/{OCCUPATION}/g, leaddata.occupation);
        email_body = email_body.replace(/{SPOUSE_OCCUPATION}/g, leaddata.spouse_occupation);
        email_body = email_body.replace(/{MORTGAGE_AMOUNT}/g, leaddata.mortgage_amount);
        email_body = email_body.replace(/{MORTGAGE_TERM}/g, leaddata.mortgage_term);
        email_body = email_body.replace(/{HOME_VALUE}/g, leaddata.home_value);
        email_body = email_body.replace(/{LENDER}/g, leaddata.lender);
        email_body = email_body.replace(/{MONTHLY_MORTAGE_PAYMENT}/g, leaddata.monthly_mortage_payment);
        email_body = email_body.replace(/{PURCHASE_REFI}/g, leaddata.purchase_refi);
        email_body = email_body.replace(/{BENEFICIARY}/g, leaddata.beneficiary);
        email_body = email_body.replace(/{ASSIGN_DATE}/g, leaddata.assign_date);
        email_body = email_body.replace(/{SALSE_REP_NAME}/g, leaddata.salse_rep_name);
        email_body = email_body.replace(/{STATUS}/g, leaddata.status);
        email_body = email_body.replace(/{LEAD_LEVEL}/g, leaddata.lead_level);
        email_body = email_body.replace(/{REFERRER}/g, leaddata.referrer);
        email_body = email_body.replace(/{COMMENTS}/g, leaddata.comments);
        email_body = email_body.replace(/{PDF}/g, leaddata.pdf);
        
        email_body = email_body.replace(/{USCITIZON}/g, leaddata.uscitizon);
        email_body = email_body.replace(/{WORKTIMEZONE}/g, leaddata.worktimezone);
        email_body = email_body.replace(/{ISFELONY}/g, leaddata.isfelony);
        email_body = email_body.replace(/{PREVIOUSEMPLOYMENT}/g, leaddata.previousemployment);
        email_body = email_body.replace(/{MOSTLIKE}/g, leaddata.mostlike);
        email_body = email_body.replace(/{LEASTLIKE}/g, leaddata.leastlike);
        email_body = email_body.replace(/{INCOME}/g, leaddata.income);

        email_body = email_body.replace(/{AGENT_FIRSTNAME}/g, tempdata.agfirst_name);
        email_body = email_body.replace(/{AGENT_LASTNAME}/g, tempdata.aglast_name);
        email_body = email_body.replace(/{AGENT_CONTACT}/g, tempdata.agcontact);
        email_body = email_body.replace(/{AGENT_EMAIL}/g, tempdata.agemail);
        email_body = email_body.replace(/{AGENT_FULLNAME}/g, tempdata.agfirst_name + " " + tempdata.aglast_name);
        email_body = email_body.replace(/{FIELD_1}/g, leaddata.field_1);
        email_body = email_body.replace(/{FIELD_2}/g, leaddata.field_2);
        email_body = email_body.replace(/{FIELD_3}/g, leaddata.field_3);
        email_body = email_body.replace(/{FIELD_4}/g, leaddata.field_4);
        email_body = email_body.replace(/{FIELD_5}/g, leaddata.field_5);
        email_body = email_body.replace(/{FIELD_6}/g, leaddata.field_6);
        email_body = email_body.replace(/{FIELD_7}/g, leaddata.field_7);
        email_body = email_body.replace(/{FIELD_8}/g, leaddata.field_8);
        email_body = email_body.replace(/{FIELD_9}/g, leaddata.field_9);
        email_body = email_body.replace(/{FIELD_10}/g, leaddata.field_10);
        email_body = email_body.replace(/{FIELD_11}/g, leaddata.field_11);
        email_body = email_body.replace(/{FIELD_12}/g, leaddata.field_12);
        email_body = email_body.replace(/{FIELD_13}/g, leaddata.field_13);
        email_body = email_body.replace(/{FIELD_14}/g, leaddata.field_14);
        email_body = email_body.replace(/{FIELD_15}/g, leaddata.field_15);
        email_body = email_body.replace(/{FIELD_16}/g, leaddata.field_16);
        email_body = email_body.replace(/{FIELD_17}/g, leaddata.field_17);
        email_body = email_body.replace(/{FIELD_18}/g, leaddata.field_18);
        email_body = email_body.replace(/{FIELD_19}/g, leaddata.field_19);
        email_body = email_body.replace(/{FIELD_20}/g, leaddata.field_20);
        email_body = email_body.replace(/{FIELD_21}/g, leaddata.field_21);
        email_body = email_body.replace(/{FIELD_22}/g, leaddata.field_22);
        email_body = email_body.replace(/{FIELD_23}/g, leaddata.field_23);
        email_body = email_body.replace(/{FIELD_24}/g, leaddata.field_24);
        email_body = email_body.replace(/{FIELD_25}/g, leaddata.field_25);
        email_body = email_body.replace(/{FIELD_26}/g, leaddata.field_26);
        email_body = email_body.replace(/{FIELD_27}/g, leaddata.field_27);
        email_body = email_body.replace(/{FIELD_28}/g, leaddata.field_28);
        email_body = email_body.replace(/{FIELD_29}/g, leaddata.field_29);
        email_body = email_body.replace(/{FIELD_30}/g, leaddata.field_30);
        email_body = email_body.replace(/{FIELD_31}/g, leaddata.field_31);
        email_body = email_body.replace(/{FIELD_32}/g, leaddata.field_32);
        email_body = email_body.replace(/{FIELD_33}/g, leaddata.field_33);
        email_body = email_body.replace(/{FIELD_34}/g, leaddata.field_34);
        email_body = email_body.replace(/{FIELD_35}/g, leaddata.field_35);
        email_body = email_body.replace(/{FIELD_36}/g, leaddata.field_36);
        email_body = email_body.replace(/{FIELD_37}/g, leaddata.field_37);
        email_body = email_body.replace(/{FIELD_38}/g, leaddata.field_38);
        email_body = email_body.replace(/{FIELD_39}/g, leaddata.field_39);
        email_body = email_body.replace(/{FIELD_40}/g, leaddata.field_40);
        email_body = email_body.replace(/{FIELD_41}/g, leaddata.field_41);
        email_body = email_body.replace(/{FIELD_42}/g, leaddata.field_42);
        email_body = email_body.replace(/{FIELD_43}/g, leaddata.field_43);
        email_body = email_body.replace(/{FIELD_44}/g, leaddata.field_44);
        email_body = email_body.replace(/{FIELD_45}/g, leaddata.field_45);
        email_body = email_body.replace(/{FIELD_46}/g, leaddata.field_46);
        email_body = email_body.replace(/{FIELD_47}/g, leaddata.field_47);
        email_body = email_body.replace(/{FIELD_48}/g, leaddata.field_48);
        email_body = email_body.replace(/{FIELD_49}/g, leaddata.field_49);
        email_body = email_body.replace(/{FIELD_50}/g, leaddata.field_50);

        /** spinner variable replacement **/
        if (email_body) {
            let qualityRegex: any = /\[[^\]]*\]/g,
                matches: any,
                qualities: string[] = [],
                spinner: string[] = [];

            while (matches = qualityRegex.exec(email_body)) {
                qualities.push(decodeURIComponent(matches));
            }
            if (qualities && Array.isArray(qualities)) {
                qualities.forEach(function (value, key) {
                    let n_value: any = value.replace(/[\[\]']+/g, '');
                    n_value = n_value.split('|');
                    spinner.push(n_value[Math.floor(Math.random() * n_value.length)]);
                });
            }
            let r_str: any = email_body;
            if (email_body.indexOf("&#91;")) {
                r_str = r_str.replace(/\[/g, '&#91;');
            }
            if (email_body.indexOf("&#93;")) {
                r_str = r_str.replace(/\]/g, '&#93;');
            }
            if (email_body.indexOf("&#124;")) {
                r_str = r_str.replace(/\|/g, '&#124;');
            }
            email_body = r_str;
            if (spinner && Array.isArray(spinner)) {
                spinner.forEach(function (value, key) {
                    let n_key: any = qualities[key];
                    let r_str: any = n_key;
                    if (n_key.indexOf("&#91;")) {
                        r_str = r_str.replace(/\[/g, '&#91;');
                    }
                    if (n_key.indexOf("&#93;")) {
                        r_str = r_str.replace(/\]/g, '&#93;');
                    }
                    if (n_key.indexOf("&#124;")) {
                        r_str = r_str.replace(/\|/g, '&#124;');
                    }
                    n_key = r_str;
                    let regex: any = new RegExp(n_key, "gi");
                    // console.log(regex, value);
                    email_body = email_body.replace(regex, value);
                });
            }
        }
        /** /--spinner variable replacement **/

        email_body = email_body.replace(/null/g, '');
        email_body = email_body.replace(/undefined/g, '');
        email_body = email_body.replace(/[{()}]/g, '');

        setTimeout(() => { callback(1, email_body); }, 200);

    }

}
